(() => {
    const mq = window.matchMedia('(max-width: 989px)');

    function init() {
        const toggle = document.getElementById('ShSearchToggle');
        if (!toggle) return;

        toggle.addEventListener('click', (e) => {
            if (!mq.matches) return;
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // Open the search overlay instead of inline bar
            document.dispatchEvent(new Event('sh-search-open-request'));
        }, true); // capture phase
    }

    document.addEventListener('DOMContentLoaded', init);
})();